import api from './api'

export const brandsService = {
  getAllAdmin: async () => {
    const res = await api.get('/brands/admin')
    return res.data.data
  },

  getAllPublic: async () => {
    const res = await api.get('/brands')
    return res.data.data
  },

  create: async (data) => {
    const res = await api.post('/brands', data)
    return res.data.data
  },

  update: async (id, data) => {
    const res = await api.patch(`/brands/${id}`, data)
    return res.data.data
  },

  delete: async (id) => {
    await api.delete(`/brands/${id}`)
  },
}
